module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/payroll-process-details/payroll-finalize-payroll/payroll-finalize-payroll.component.css
// module id = ./src/app/hrms/payroll/payroll-process-details/payroll-finalize-payroll/payroll-finalize-payroll.component.css
// module chunks = main